const normalizeSipStatus = (status) =>
  String(status || '')
    .trim()
    .toUpperCase()

export const isActiveSipStatus = (status) => normalizeSipStatus(status) === 'ACTIVE'

export const isInactiveSipStatus = (status) =>
  ['CANCELLED', 'PAUSE', 'PAUSED'].includes(normalizeSipStatus(status))

export const getSipStatusLabel = (status) => {
  const normalizedStatus = normalizeSipStatus(status)

  if (['PAUSE', 'PAUSED'].includes(normalizedStatus)) return 'Paused'

  return normalizedStatus
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
